export default __webpack_public_path__ + "static/media/swoosh_normal.87392f10.mp3";